var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Installateur",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Installateur .cls-1 {\n        fill: none;\n      }\n\n      #Installateur .cls-2 {\n        clip-path: url(#Installateur-clip-path);\n      }\n\n      #Installateur .cls-3 {\n        fill: #a771ff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "Installateur-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,32A16,16,0,1,1,32,16,16,16,0,0,1,16,32M16,1.72A14.28,14.28,0,1,0,30.28,16,14.28,14.28,0,0,0,16,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.522,11.806c-.394-.016-.794-.007-1.194-.007-1.252,0-2.5,0-3.756-.006a8.82,8.82,0,0,1-.048,4.3h.517q2.188,0,4.375-.01a2.171,2.171,0,0,0,1.038-.226,2.12,2.12,0,0,0,1.135-1.771c0-.013,0-.026,0-.039a2.158,2.158,0,0,0-2.069-2.244m.8,2.878v0a1.112,1.112,0,0,1-1.553-.029l-.016-.016a1.039,1.039,0,0,1,.032-1.469,1.086,1.086,0,0,1,1.524-.021,1.126,1.126,0,0,1,.013,1.532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.6,23.431l-3.971-3.97a1.163,1.163,0,0,0-.472-.278,8.515,8.515,0,1,0-1.52,1.434,1.164,1.164,0,0,0,.292.544l3.971,3.97a1.2,1.2,0,0,0,.849.352l0,0a1.2,1.2,0,0,0,.848-2.049M13.655,21.068a7.21,7.21,0,1,1,7.21-7.21,7.21,7.21,0,0,1-7.21,7.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.558,11.253c-.371,0-.741,0-1.112,0a1.18,1.18,0,0,1-.73-.254,2.109,2.109,0,0,1-.256-.253,4.72,4.72,0,0,0-5.433-1.081,4.419,4.419,0,0,0-2.338,2.4c-.035.078-.024.105.065.105.277.007.555.028.833.028h2.187a6.933,6.933,0,0,1,.934.033.878.878,0,0,1,.8.776,1.731,1.731,0,0,1,.03.268c.008.282.016.564.016.846a4.052,4.052,0,0,1-.094,1.03.849.849,0,0,1-.676.663,2.469,2.469,0,0,1-.6.065l-3.326-.043a.327.327,0,0,0-.132.009c-.009.038.015.066.032.1a4.319,4.319,0,0,0,.757,1.141,4.7,4.7,0,0,0,3.165,1.545,4.234,4.234,0,0,0,3.313-1.1,4.108,4.108,0,0,1,.371-.312,2.428,2.428,0,0,1,1.464-.4h.56a6.391,6.391,0,0,0,.17-5.57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaller);
export default __webpack_public_path__ + "static/media/installer.71bd4bf59a4bc630e4ef35ebd7518a59.svg";
export { ForwardRef as ReactComponent };